import React from "react";

import { useApp } from "../contexts/app";
import { pieceKind, Player } from "../types/game";
import { BoardPieceImage } from "./geometry/BoardPieceImage";
import { Typography } from "@mui/material";

export const PiecesRoster = () => {
  const {
    state: {
      game: { turnOfPlayer, turn },
    },
  } = useApp();

  const queenNotYetPlaced = turnOfPlayer.piecesRoster.queen === 1;

  const roster =
    queenNotYetPlaced && turn >= 3
      ? Object.entries(turnOfPlayer.piecesRoster).filter(
          (r) => r[0] === "queen"
        )
      : Object.entries(turnOfPlayer.piecesRoster).filter((r) => r[1] > 0);

  return (
    <div
      className="border d-flex flex-landscape-column justify-content-center"
      style={{ flexDirection: "row" }}
    >
      {roster.map((e) => (
        <AvailablePieces
          key={e[0]}
          kind={e[0] as pieceKind}
          number={e[1]}
          owner={turnOfPlayer}
        />
      ))}
    </div>
  );
};

const AvailablePieces = ({
  owner,
  kind,
  number,
}: {
  owner: Player;
  kind: pieceKind;
  number: number;
}) => {
  return (
    <div
      className="d-flex align-items-center flex-landscape-row"
      style={{ flexDirection: "column" }}
    >
      <BoardPieceImage kind={kind} owner={owner} />
      <Typography variant="h5" color="#8D8C92">
        x{number}
      </Typography>
    </div>
  );
};
